module.exports = __webpack_public_path__ + "static/media/primary_weapon_attack.f9f52d02.png";